// Amadeus dictionary extractor. Probes every known surface on an
// Amadeus search / flightOffersPrice / seatmap / upsell / confirm
// response (top-level body, axios `data` envelope, salabam
// `flightVoucher` confirm wrapper) and returns a single canonical
// `{ locations, carriers }` block. Pair with `merge_dictionaries`
// from `../base/helpers` to fold the result into the provider's
// IATA → name caches.

import { get_object_field } from '@/utilities/commons'

const KNOWN_DICT_PATHS = [
  'dictionaries',
  'data.dictionaries',
  'flightVoucher.orderData.dictionaries',
  'data.flightVoucher.orderData.dictionaries',
]

const fold_canonical_block = (acc, dict) => {
  if (!dict || typeof dict !== 'object') return
  const { carriers = {}, locations = {} } = dict
  Object.keys(carriers).forEach((code) => {
    acc.carriers[code] = carriers[code]
  })
  Object.keys(locations).forEach((iata) => {
    const entry = locations[iata] || {}
    const existing = acc.locations[iata] || {}
    acc.locations[iata] = {
      name: entry.name || existing.name || '',
      cityCode: entry.cityCode || existing.cityCode || '',
      cityName: entry.cityName || existing.cityName || '',
    }
  })
}

/**
 * Probe every known dictionary surface on an Amadeus response and fold
 * them into a single canonical block. Pair with `merge_dictionaries`
 * to fold the result into the provider's IATA → name caches.
 *
 * @param {Object} source
 * @returns {{ locations: Object, carriers: Object }}
 */
export const extract_dictionaries = (source) => {
  const acc = { locations: {}, carriers: {} }
  if (!source || typeof source !== 'object') return acc
  KNOWN_DICT_PATHS.forEach((path) => {
    fold_canonical_block(acc, get_object_field(source, path, null))
  })
  return acc
}
